import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";

function NewBooking() {
  const [categoryList, setCategoryList] = useState([]);
  const [form, setForm] = useState({
    categoryId: "",
    startDate: "",
    endDate: ""
  });
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    setItems([]);
  }, [form.categoryId, form.startDate, form.endDate]);

  const fetchCategories = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}/category`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      setCategoryList(res.data.data);
    } catch (err) {
      console.error("Gagal mengambil kategori", err);
    }
  };

  const isVillaOrHotel = () => {
    const selected = categoryList.find(
      (cat) =>
        cat.category_id === form.categoryId || cat.categoryId === form.categoryId
    );
    const name = selected?.name?.toLowerCase();
    return name === "villa" || name === "hotel";
  };

  const formatDateLocal = (date) => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleStartDateChange = (dates) => {
    const date = dates[0];
    if (!date) return;
    setStartDate(date);
    setEndDate(null);
    setForm(prev => ({
      ...prev,
      startDate: formatDateLocal(date),
      endDate: ""
    }));
  };

  const handleEndDateChange = (dates) => {
    const date = dates[0];
    setEndDate(date);
    setForm(prev => ({
      ...prev,
      endDate: formatDateLocal(date)
    }));
  };

  const getEndDateMin = () => {
    if (!startDate) return new Date();
    const min = new Date(startDate);
    if (isVillaOrHotel()) min.setDate(min.getDate() + 1);
    return min;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/show-available-items`, {
        category_id: form.categoryId,
        start_date: form.startDate,
        end_date: form.endDate
      });
      setItems(response.data.data);
    } catch (err) {
      console.error("Gagal memuat item tersedia", err);
    }
  };

  const formatDateToDDMMYYYY = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Sidebar />
        <div className="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
          <Navbar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <div className="row px-4">
                <div className="card shadow p-3 mb-4">
                  <h5 className="card-title mb-4">Cari Ketersediaan</h5>
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3 align-items-end">
                      <div className="col-md-4">
                        <label className="form-label">Kategori</label>
                        <select
                          className="form-select"
                          name="categoryId"
                          value={form.categoryId}
                          onChange={(e) => setForm({ ...form, categoryId: e.target.value })}
                        >
                          <option value="">Pilih Kategori</option>
                          {categoryList.map((cat) => (
                            <option key={cat.category_id} value={cat.category_id}>
                              {cat.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">Check-in</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bx bx-calendar"></i>
                          </span>
                          <Flatpickr
                            className="form-control"
                            value={startDate}
                            options={{ dateFormat: "Y-m-d" }}
                            onChange={handleStartDateChange}
                          />
                        </div>
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">Check-out</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bx bx-calendar"></i>
                          </span>
                          <Flatpickr
                            className="form-control"
                            value={endDate}
                            options={{ dateFormat: "Y-m-d", minDate: getEndDateMin() }}
                            onChange={handleEndDateChange}
                            disabled={!startDate}
                          />
                        </div>
                      </div>

                      <div className="col-md-2 d-grid">
                        <button className="btn btn-primary" type="submit">
                          Cari
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                {/* Menampilkan Hasil */}
                {items.length > 0 && (
                  <div className="row g-0">
                    {items.map((item) => (
                      <div className="col-12 mb-3" key={item.item_id}>
                        <div
                          className="card shadow d-flex flex-row"
                          style={{ height: "260px", cursor: "pointer" }}
                          onClick={() => {
                            const query = new URLSearchParams({
                              category_id: form.categoryId,
                              start_date: formatDateToDDMMYYYY(startDate),
                              end_date: formatDateToDDMMYYYY(endDate)
                            }).toString();
                            // navigate(`/new-booking/${item.item_id}?${query}`);
                            navigate(`/new-booking/${item.item_id}?${query}`, {
                              state: {
                                item: item,
                                category: {
                                  categoryId: form.categoryId,
                                  categoryName: categoryList.find(
                                    c => c.category_id === form.categoryId
                                  )?.name
                                }
                              }
                            });
                          }}
                        >
                          <div className="w-25">
                            <img
                              src={`${process.env.REACT_APP_API}/images/${item.imageId[0]?.imageUrl}`}
                              alt={item.title}
                              className="img-fluid w-100 h-100 rounded-start"
                              style={{ objectFit: "cover" }}
                            />
                          </div>
                          <div className="w-75 p-3">
                            <div className="d-flex justify-content-between">
                              <div>
                                <div className="row">
                                  <div className="col-7">
                                    <h5>{item.title}</h5>
                                    <p className="mb-2">{item.city}, {item.country}</p>
                                  </div>
                                  <div className="col-5">
                                    <div className="text-end d-flex align-items-center justify-content-end">
                                      <h4 className="fw-bold m-1">
                                        Rp {item.price.toLocaleString()}
                                      </h4>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  {item.featureId.map((feature, index) => {
                                    const colClass =
                                      item.featureId.length > 6 ? "col-4" : "col-6";
                                    return (
                                      <div
                                        key={feature._id}
                                        className={`${colClass} d-flex align-items-center mb-2`}
                                      >
                                        <img
                                          src={`${process.env.REACT_APP_API}/images/${feature.imageUrl}`}
                                          alt={feature.name}
                                          title={feature.name}
                                          style={{
                                            width: "28px",
                                            height: "28px",
                                            objectFit: "contain",
                                            marginRight: "8px"
                                          }}
                                        />
                                        <span style={{ fontSize: "0.875rem" }}>
                                          {feature.qty > 1 ? `${feature.qty} ` : ""}
                                          {feature.name}
                                        </span>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="layout-overlay layout-menu-toggle"></div>
    </div>
  );
}

export default NewBooking;